import { Button } from "../../components/Button";
import { Card } from "../../components/Card";
import { PersonalDataConsent } from "../../components/PersonalDataConsent";
import { PROMO_EACH } from "./constants";

export function PromotionsPhonePromoCard({
  phone,
  setPhone,
  err,
  ok,
  submitting,
  onSubmit,
  onOpenPrivacyPolicy,
}) {
  return (
    <Card
      variant="light"
      className="promotionsPromoCard"
      title={`Укажите номер телефона — ${PROMO_EACH} бонусов`}
      subtitle="Российский номер, 10 или 11 цифр. Сохраняется в едином формате. Одноразово."
    >
      <form className="promotionsPromoCard__form" onSubmit={onSubmit}>
        <PersonalDataConsent
          consentId="promo-pd-consent-phone"
          onOpenPrivacyPolicy={onOpenPrivacyPolicy}
        />
        <label className="field">
          Телефон
          <input
            type="tel"
            autoComplete="tel"
            placeholder="+7 900 123-45-67"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />
        </label>
        {err ? <p className="errorMessage">{err}</p> : null}
        {ok ? <p className="successMessage">{ok}</p> : null}
        <Button type="submit" variant="accent" disabled={submitting}>
          {submitting ? "Отправка…" : `Получить ${PROMO_EACH} бонусов`}
        </Button>
      </form>
    </Card>
  );
}
